import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import Title from "../common/title"
import { graphql, Link } from "gatsby"
import Media from "../common/media"
import { generateUrlByLocale } from "../../services/intl.service"
import { getSrc } from "gatsby-plugin-image"
import Slider from "react-slick"
import { useStaticQuery } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"

const PushExperience = ({ experiences }) => {
const intl = useIntl()
const data = useStaticQuery(graphql`
  query {
    TaxonomyGenreFR: allTaxonomyTermGenre(
      filter: { langcode: { eq: "fr" } }
    ) {
      nodes {
        name
        id
        drupal_internal__tid
      }
    }
    TaxonomyGenreEN: allTaxonomyTermGenre(
      filter: { langcode: { eq: "en" } }
    ) {
      nodes {
        name
        id
        drupal_internal__tid
      }
    }
  }
`)
let taxonomyGenre
switch (intl.locale) {
  case "fr":
    if (data.TaxonomyGenreFR) {
      taxonomyGenre = data.TaxonomyGenreFR.nodes
    }
    break
  default:
    if (data.TaxonomyGenreEN) {
      taxonomyGenre = data.TaxonomyGenreEN.nodes
    }
  }
  const listItems = experiences?.relationships.experience_article?.map(
    (list, index) => {
      const matchedGenre = taxonomyGenre.find((matchId) => list.genre?.drupal_internal__target_id === matchId?.drupal_internal__tid)
      const genreName = matchedGenre?.name || "";
      return (
        <Col xs={6} key={index}>
        <Link to={generateUrlByLocale(list.path.langcode, list.path.alias)}>
          <div className="blk-key">
            <div className="animImgTop">
              {/* <span className="caption">
                {list.relationships.experience?.name}
              </span> */}
              <Media
                media={
                  list.relationships?.experience_article_featured_land
                    ? list.relationships.experience_article_featured_land
                        ?.relationships?.featured_media_media
                    : ""
                }
              />
              </div>
              <div className="blk-key-infos justify-content-left alignLeft">
                {genreName && (
                  <span className="caption pushExp_genre">{genreName}</span>
                )}
                <h3 className="font-style_2 primaryCol">{list.title}</h3>
                <Link className='simpleLink' to={generateUrlByLocale(list.path.langcode, list.path.alias)}>{intl.formatMessage({ id: "discover" })}</Link>
              </div>
            </div>
          </Link>
        </Col>
      )
      }
  )

  const settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  }

  const bgImage = experiences.relationships.cover_image
    ? getSrc(experiences.relationships.cover_image.relationships.field_image?.gatsbyImage)
    : ""

  return (
    <div
      id="pushExperience"
      className="blk-push"
      //style={{ backgroundImage: "url(" + bgImage + ")" }}
    >
      {bgImage && (
        <span
          className="cover-bg"
          style={{
            backgroundImage: "url(" + bgImage + ")",
          }}
        ></span>
      )}
      <Container>
        <Row>
          <Col>
            <Title text={experiences.push_experience_title} align="center" />
          </Col>
        </Row>
      </Container>
      <Container className={listItems.length > 2 ? "blk-spacing" : "blk-spacing"}>
        <Row>
          <Slider {...settings} className="pushSlider">
            {listItems}
          </Slider>
        </Row>
      </Container>
    </div>
  )
}

export const query = graphql`
  fragment getPushExperiences on paragraph__push_experience {
    push_experience_title
    relationships {
      cover_image {
        field_image {
          alt
        }
        relationships {
          ...getImage
        }
      }
      experience_article {
        title
        genre {
          drupal_internal__target_id
        }
        path {
          alias
          langcode
        }
        relationships {
          experience_article_featured_land {
            ...getFeaturedMedia
          }
          experience {
            name
          }
        }
      }
      cover_image {
        field_image {
          alt
        }
        relationships {
          ...getImage
        }
      }
    }
  }
`

export default PushExperience
